import React, { Component } from 'react';

// ภาษาที่รองรับทั้งหมด (รหัสตรงกับ dictionary ใน i18n.js)
const LANGUAGES = [
  { code: 'th', label: 'ภาษาไทย',     short: 'TH', img: 'https://flagcdn.com/w40/th.png' },
  { code: 'en', label: 'English',      short: 'EN', img: 'https://flagcdn.com/w40/gb.png' },
  { code: 'zh', label: '中文',          short: 'ZH', img: 'https://flagcdn.com/w40/cn.png' },
  { code: 'ja', label: '日本語',        short: 'JP', img: 'https://flagcdn.com/w40/jp.png' },
  { code: 'my', label: 'မြန်မာဘာသာ',   short: 'MY', img: 'https://flagcdn.com/w40/mm.png' },
  { code: 'lo', label: 'ພາສາລາວ',      short: 'LO', img: 'https://flagcdn.com/w40/la.png' },
];

/**
 * LanguageSwitcher — ปุ่ม pill แสดงภาษาปัจจุบัน
 * กดแล้วเด้ง popup ให้เลือกภาษา 6 ภาษา
 * props: language (รหัสภาษาปัจจุบัน), onChange (เรียกเมื่อเลือกภาษาใหม่), size ('sm'|'md')
 */
class LanguageSwitcher extends Component {
  state = { open: false };

  open = () => this.setState({ open: true });
  close = () => this.setState({ open: false });

  select = (code) => {
    localStorage.setItem('lang', code);
    if (this.props.onChange) this.props.onChange(code);
    this.setState({ open: false });
  };

  render() {
    const { language = 'th', size = 'md' } = this.props;
    const { open } = this.state;
    const sm = size === 'sm';
    const current = LANGUAGES.find((l) => l.code === language) || LANGUAGES[0];

    const pill = {
      display: 'inline-flex', alignItems: 'center', gap: 6, cursor: 'pointer',
      padding: sm ? '4px 9px' : '6px 12px', borderRadius: 22,
      border: '2px solid rgba(245,88,123,0.55)', background: 'rgba(245,88,123,0.12)',
      userSelect: 'none', whiteSpace: 'nowrap',
    };
    const pillImg = { width: sm ? 22 : 26, height: sm ? 15 : 18, borderRadius: 3, objectFit: 'cover', boxShadow: '0 1px 3px rgba(0,0,0,.4)' };
    const pillLabel = { color: '#fff', fontWeight: 700, fontSize: sm ? 12 : 13 };
    const arrow = { color: '#f5587b', fontSize: 10 };

    const backdrop = {
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
      backdropFilter: 'blur(3px)', WebkitBackdropFilter: 'blur(3px)',
      zIndex: 99999, display: 'flex', alignItems: 'center', justifyContent: 'center',
    };
    const modal = {
      background: 'linear-gradient(150deg,#1d2440,#121627)', border: '1px solid rgba(245,88,123,0.35)',
      borderRadius: 18, padding: '22px 18px 18px', width: 320, maxWidth: '92vw',
      boxShadow: '0 16px 48px rgba(0,0,0,.7)', position: 'relative',
    };
    const title = { color: '#f5587b', fontWeight: 700, fontSize: 16, textAlign: 'center', marginBottom: 16 };
    const closeBtn = { position: 'absolute', top: 10, right: 14, cursor: 'pointer', color: '#aaa', fontSize: 20, lineHeight: 1 };
    const grid = { display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10 };
    const item = (active) => ({
      display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, cursor: 'pointer',
      padding: '10px 6px', borderRadius: 12,
      border: active ? '2px solid #f5587b' : '2px solid rgba(255,255,255,0.08)',
      background: active ? 'rgba(245,88,123,0.18)' : 'rgba(255,255,255,0.05)',
    });
    const itemImg = { width: 38, height: 25, borderRadius: 4, objectFit: 'cover', boxShadow: '0 2px 6px rgba(0,0,0,.4)' };
    const itemShort = (active) => ({ color: active ? '#f5587b' : '#bbb', fontWeight: active ? 700 : 500, fontSize: 11 });
    const itemLabel = (active) => ({ color: active ? '#fff' : '#999', fontSize: 10, textAlign: 'center' });

    return (
      <>
        <div style={pill} onClick={this.open}>
          <img src={current.img} alt={current.label} style={pillImg} onError={(e) => { e.target.style.display = 'none'; }} />
          <span style={pillLabel}>{current.label}</span>
          <span style={arrow}>▾</span>
        </div>

        {open && (
          <div style={backdrop} onClick={this.close}>
            <div style={modal} onClick={(e) => e.stopPropagation()}>
              <span style={closeBtn} onClick={this.close}>✕</span>
              <div style={title}>🌐 เลือกภาษา / Select Language</div>
              <div style={grid}>
                {LANGUAGES.map((l) => {
                  const active = language === l.code;
                  return (
                    <div key={l.code} style={item(active)} onClick={() => this.select(l.code)}>
                      <img src={l.img} alt={l.label} style={itemImg} onError={(e) => { e.target.style.display = 'none'; }} />
                      <span style={itemShort(active)}>{l.short}</span>
                      <span style={itemLabel(active)}>{l.label}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default LanguageSwitcher;
